"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
const wp_query_params = {
  per_page: 10
};
const wp_query = new WP_Query(wp_query_params);
function ProductGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="174534" className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
        {[...Array(10)].map((_, i) => <div key={i} data-index={i} className="h-72 bg-muted/30 animate-pulse rounded-sm border border-border" />)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="text-center text-muted-foreground font-sans py-12">
        No research compounds found at this time.
      </div>;
  }
  return <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="group overflow-hidden border border-border bg-card hover:shadow-lg hover:border-primary/30 transition-all duration-300 flex flex-col h-full rounded-sm">
          <Link to={product.link} className="flex-grow flex flex-col">
            <CardContent className="p-3 md:p-4 flex-grow flex flex-col items-center justify-start">
              <div className="w-full mb-4 md:mb-6 relative">
                <AspectRatio ratio={1}>
                  {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="object-contain w-full h-full group-hover:scale-105 transition-transform duration-700 p-1" loading="lazy" /> : <div className="w-full h-full bg-muted/20 flex items-center justify-center rounded-sm">
                      <span className="text-muted-foreground font-mono text-[10px] uppercase tracking-widest text-center px-2">
                        Compound Image Missing
                      </span>
                    </div>}
                </AspectRatio>
              </div>
              <div className="flex flex-col items-center text-center mt-auto w-full">
                <h3 className="font-medium text-secondary tracking-tight text-base md:text-lg leading-tight line-clamp-2 mb-2 font-sans">
                  {product.title}
                </h3>
                {product.price !== undefined && <p className="text-primary font-mono text-sm md:text-base font-bold mb-3">
                    {product.price.toFixed(2)} USD
                  </p>}
              </div>
            </CardContent>
          </Link>
          <div className="p-4 pt-0 mt-auto w-full">
            <Link to={product.link} className="w-full block">
              <div className="bg-primary text-primary-foreground hover:bg-primary/80 active:bg-secondary active:text-secondary-foreground w-full py-5 rounded-sm font-sans text-base font-medium uppercase tracking-widest transition-all duration-200 text-center">
                View Compound
              </div>
            </Link>
          </div>
        </Card>)}
    </div>;
}
export default function ProductPresentation() {
  return <section id="featuredresearchpeptides" className="py-12 md:py-16 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col items-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-5xl font-semibold text-secondary uppercase text-center tracking-widest font-sans">validated compounds</h2>
          <div className="h-[2px] w-24 bg-primary mt-6 mb-4"></div>
          <p className="text-muted-foreground text-xs md:text-sm font-sans tracking-wide uppercase">High-purity peptides for controlled laboratory environments</p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 10
      }}>
          <ProductGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}